import React, { useContext } from 'react';
import styled from 'styled-components';

import footer from '../../static/img/footer.svg';
import MyContext from '~/src/services/context';

export default function Footer(): JSX.Element {
  const currentYear = new Date().getFullYear();
  const context = useContext(MyContext);
  return (
    <MyContext.Consumer>
      {({ user }) => (
        <>
          {context.user?.isAuthenticated && (
            <Conteiner>
              <div>Copyright {currentYear} © Silva Trading. All Rights Reserved.</div>
            </Conteiner>
          )}
        </>
      )}
    </MyContext.Consumer>
  );
}

const Conteiner = styled.div`
  @media print {
    display: none !important;
  }

  background-image: url(${footer});
  background-size: cover;
  background-repeat: no-repeat;
  height: 73px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
